import { words } from "@/mandarin/words";
import type { PhraseType, SentenceType, WordType } from "@/mandarin/types";

type CharacterSet = "simplified" | "traditional";

// const lao = "老";
// const shi = "師";
// const ni = "你";
// const hao = "好";
// const le = "了";

export default class PhraseBook {
  IDX_SIMP = 1;
  IDX_TRAD = 2;
  IDX_SCORE = 3;
  IDX_PINYIN = 4;

  characterSet: CharacterSet = "traditional";
  matches: RegExpMatchArray[];

  constructor() {
    const lineFormat = /(\S+)__(\S+) ([\d\.]+)\|(.+);/;
    const lines = words.split("\n");
    this.matches = lines
      .map((line) => {
        if (lineFormat) {
          const match = line.match(lineFormat);
          return match ?? undefined;
        }
        return undefined;
      })
      .filter((m): m is RegExpMatchArray => Boolean(m));
  }

  parseSentence(message: string): SentenceType[] {
    return this.parseHanyu(message);
  }

  parseHanyu(message: string): SentenceType[] {
    if (!message) {
      return [];
    }

    const sentences: SentenceType[] = [
      {
        phrases: [],
        meaning: "",
      },
    ];

    const chars = message.split("");
    const peek = (i: number) => chars[i];

    while (chars.length) {
      let hanyuSequence = [];
      let i = 0;
      let next;
      while ((next = peek(i++))) {
        if (this.getPinyinForChar([...hanyuSequence, next].join(""))) {
          hanyuSequence.push(next);
        } else {
          break;
        }
      }

      if (hanyuSequence.length) {
        // Consume the chars we peeked at
        while (--i) {
          chars.shift();
        }

        const pinyin = (this.getPinyinForChar(hanyuSequence.join("")) ?? "").split(" ");
        // console.log({ sequence, pinyin });

        const phrase: PhraseType = {
          words: hanyuSequence.map(
            (character, i): WordType => ({
              character,
              pinyin: pinyin[i],
              english: "",
            })
          ),
          meaning: "",
        };

        sentences.at(-1)?.phrases.push(phrase);
      } else if (["."].includes(peek(0))) {
        // We need to close this sentence
        // start a new one if we peek more chars
      } else {
        // No sequence, drop the character
        chars.shift();
      }
    }

    return sentences;
  }

  parsePinyin(message: string): SentenceType[] {
    if (!message) {
      return [];
    }
    return [];
  }

  parseEnglish(message: string): SentenceType[] {
    if (!message) {
      return [];
    }
    return [];
  }

  getPinyinForChar(char: string): string | undefined {
    const matchIndex = this.characterSet === "simplified" ? this.IDX_SIMP : this.IDX_TRAD;
    return this.matches.find((match) => {
      return match[matchIndex] === char;
    })?.[this.IDX_PINYIN];
  }
}
